import './App.css';
import * as THREE from "three";
import React from "react";
// import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
// import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
// import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';
import { FlakesTexture } from 'three/examples/jsm/textures/FlakesTexture.js';
import { Lensflare, LensflareElement } from 'three/examples/jsm/objects/Lensflare.js';
import { TextureLoader } from 'three';
import { SketchPicker } from 'react-color';

// import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader.js';

const TWEEN = require('@tweenjs/tween.js')
const spinnerEl = document.getElementById('spinner');
const backgroundEl = document.getElementById('loading-background');

Object.size = function(obj) {
  var size = 0, key;
  for (key in obj) {
      if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};

var OrbitControls = require('three-orbitcontrols')
var fbxLoader = new FBXLoader();

var threeJSScene;
var threeJSSceneObjects = []; 

var camera;
var cubeCamera;
let pointLightF1;
let pointLightRear1;
let spotLigtNight;
let carInteriorLightL;
let carInteriorLightR;
let headlightL;
let headlightR;
let carLightsMtl;
let intPlasticMtl;

var renderer;
var controls;
var metalObjectNames = ["mesh_Ext_object__A","mesh_Door__L","mesh_Door__R","mesh_Ext_object__Trunk"];
var brushedMetalObjectNames = ["mesh_Ext_object__D","mesh_Ext_object__C","mesh_Ext_object__E","mesh_Tyre__B","mesh_Tyre__C","mesh_Door__C","mesh_Door__D"];
var chromeMirrorObjectNames = ["Chrome","R_Mirror","L_mirror","r_view_mirror"];
var glassWithOpacityMapObjectNames = ["mesh_Wndshield_Glasses"];
var glassObjectNames = ["mesh_Head_light_glasses","mesh_Sunroof_glass__A","mesh_Sunroof_glass__B","mesh_L_Door_glass","mesh_R_Door_glass","mesh_Back_glass__1","mesh_Back_glass__2"];
var exteriorPlasticObjectNames = ["mesh_Ext_object__B","mesh_SideLogo_strip__B","mesh_SideLogo_strip__A"];
var tyreObjectNames = ["mesh_Tyre__A"];
var seatObjectNames = ["mesh_Seat"];
var interiorPlastic = ["mesh_Dashboard","mesh_Door__B","mesh_Door__A","mesh_Dashboard__ConsoleBox","mesh_BCK_door", "mesh_Interior__A","mesh_Dashboard__glovebox"];
var fabricObjectNames = ["mesh_Interior__C", "mesh_trunk"];
var carLightsObjectNames = ["mesh_Head_lights", "mesh_Head_lights__Rear"];
var materialsNamesToLoad = ["roughness","opacity","normal","metalic", "emissive", "diffuse", "ao" ];

var materialMapNames = ["concrete base.jpg", "concrete base_1.jpg", "material_diffuse_Dashboard.jpg", "material_diffuse_Dashboard.png", "material_diffuse_Door.jpg", "material_diffuse_Door.png", "material_diffuse_Ext_object.jpg", "material_diffuse_Ext_object.png", "material_diffuse_ground.jpg", "material_diffuse_ground.png", "material_diffuse_Head_lights.jpg", "material_diffuse_Head_lights.png", "material_diffuse_Interior.jpg", "material_diffuse_Interior.png", "material_diffuse_Seat.jpg", "material_diffuse_Seat.png", "material_diffuse_SideLogo_strip.jpg", "material_diffuse_SideLogo_strip.png", "material_diffuse_trunk.jpg", "material_diffuse_trunk.png", "material_diffuse_Tyre.jpg", "material_diffuse_Tyre.png", "material_diffuse_Wndshield_Glasses.jpg", "material_diffuse_Wndshield_Glasses.png", "material_emissive_Dashboard.jpg", "material_emissive_Dashboard.png", "material_emissive_Door.jpg", "material_emissive_Door.png", "material_emissive_Head_lights.jpg", "material_emissive_Head_lights.png", "material_emissive_Interior.jpg", "material_emissive_Interior.png", "material_metalic_Dashboard.jpg", "material_metalic_Dashboard.png", "material_metalic_Door.jpg", "material_metalic_Door.png", "material_metalic_Ext_object.jpg", "material_metalic_Ext_object.png", "material_metalic_Head_lights.jpg", "material_metalic_Head_lights.png", "material_metalic_Interior.jpg", "material_metalic_Interior.png", "material_metalic_Seat.jpg", "material_metalic_SideLogo_strip.jpg", "material_metalic_SideLogo_strip.png", "material_metalic_Tyre.jpg", "material_metalic_Tyre.png", "material_normal_Dashboard.jpg", "material_normal_Dashboard.png", "material_normal_Dashboard_result.jpg", "material_normal_Door.jpg", "material_normal_Door.png", "material_normal_Ext_object.jpg", "material_normal_Ext_object.png", "material_normal_Head_lights.jpg", "material_normal_Head_lights.png", "material_normal_Interior.jpg", "material_normal_Interior.png", "material_normal_Seat.jpg", "material_normal_Seat.png", "material_normal_SideLogo.jpg", "material_normal_SideLogo.png", "material_normal_Tyre.jpg", "material_normal_Tyre.png", "material_opacity_Wndshield_Glasses.jpg", "material_opacity_Wndshield_Glasses.png", "material_roughness_Dashboard.jpg", "material_roughness_Dashboard.png", "material_roughness_Door.jpg", "material_roughness_Door.png", "material_roughness_Ext_object.jpg", "material_roughness_Ext_object.png", "material_roughness_Head_lights.jpg", "material_roughness_Head_lights.png", "material_roughness_Interior.jpg", "material_roughness_Interior.png", "material_roughness_Seat.jpg", "material_roughness_Seat.png", "material_roughness_SideLogo.jpg", "material_roughness_SideLogo.png", "material_roughness_Tyre.jpg", "material_roughness_Tyre.png","material_normal_trunk.jpg"];


var doorRotation = {rot:0};
var gloveBoxRotation = {rot:0};
var consoleBoxRotation = {rot:0};
var SunRoofPos = {y:6.7906, z:-1.5443};
var trunkRot = {rot:-1.5708};
var leftDoorGroup;
var gloveBox;
var consoleBox;
var sunRoof;
var Trunk;
var doorHandleExt;
var doorHandleInt;


var colorPickerDom;
var raycaster = new THREE.Raycaster();
var mouse = new THREE.Vector2();
var clickDrag = false;

// Animation Timings in miliseconds
var doorOpenCloseTime = 2000;
var sunRoofOpenCloseTime = 3500;
var camAnimToDoorOpenPosTime = 2000;
var camAnimToCarInteriorTime = 2500;
var dayNightSwitchTime = 2000;
var carColorChangeTime = 400;


var camIntPos = {x:0, y:2.13, z: 0.0};
var camTgtIntPos = {x:0, y:2.13, z:0.01};
var camExtPos = {x:4.56, y:2.57, z:10.93};
var camTgtExtPos = {x:0, y:0, z: 0};
var camCarDoorOpnPos = {x:5.176, y:2.5, z: -1.3};

var metalBodyMtl;
var chromeMtl;
var lensFlareMaterial;

var dayEnvironementMat;
var nightEnvironementMat;


var dayLightIntensity = 0.5; // day:0.5, night:0
var nightSpotLightIntensity = 0; // day: 0, night: 0.35
var headLightIntensity = 0; // day:0, night: 1.2
var carIntLightIntensity = 0; // day:0, night: 0.8
var carColor = {r:255,g:255,b:255};
var position = { cx :camExtPos.x, cy:camExtPos.y, cz:camExtPos.z, tx:camTgtExtPos.x, ty:camTgtExtPos.y, tz:camTgtExtPos.z };
var dayNightTweenProps = {dayOpacity:1, nightOpacity:0, pointLight:0.4, headLights:0, fogBGClr:255, nightSpot:0, carLights:0, carIntLight:0, metalRefEnvIntensity:1.25, chromeRefEnvIntensity:3, tyreRefEnvInt:1, lensFlareOpacity:0};
var cameraProps = {fov:60};

var isNightModeOn = false;
var isCurrentViewInterior = false;
var isDoorOpen = false;
var isGloveBoxOpen = false;
var isConsoleBoxOpen = false;
var isSunRoofOpen = false;
var isTrunkOpen = false;
var isZoomEnabled = false;

//#region Animation functions

const changeCarColor = (color) =>{
  // console.log(color);
  let target = {r:color.rgb.r, g:color.rgb.g, b:color.rgb.b};
  let tween = new TWEEN.Tween(carColor).to(target, carColorChangeTime).onUpdate(setCarColor).onComplete(
      setSunRoofOpenStatus(true)
      );
    tween.easing(TWEEN.Easing.Exponential.Out);
    tween.start();
}

const setCarColor = () =>{
  let hexClr = rgbToHex(parseInt(carColor.r),parseInt(carColor.g),parseInt(carColor.b));
  threeJSScene.getObjectByName("mesh_Ext_object__A").material.color.set(hexClr);;
  threeJSScene.getObjectByName("mesh_Door__L").material.color.set(hexClr);;
  threeJSScene.getObjectByName("mesh_Door__R").material.color.set(hexClr);;
  threeJSScene.getObjectByName("mesh_Ext_object__Trunk").material.color.set(hexClr);;
}


const openCloseTrunk = () => {
  Trunk = threeJSScene.getObjectByName("Trunk");
  if(!isTrunkOpen){
    let target = {rot:0};
    let tween = new TWEEN.Tween(trunkRot).to(target, doorOpenCloseTime).onUpdate(trunkOpen).onComplete(
        setTrunkOpenStatus(true)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
  else{
    let target = {rot:-1.5708};
    let tween = new TWEEN.Tween(trunkRot).to(target, doorOpenCloseTime).onUpdate(trunkOpen).onComplete(
        setTrunkOpenStatus(false)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
}

const trunkOpen = () =>{
  Trunk.rotation.x = trunkRot.rot;
}

const setTrunkOpenStatus = (val) =>{
  isTrunkOpen = val;
}



const openCloseSunRoof = () => {
  sunRoof = threeJSScene.getObjectByName("Sunroof");
  if(!isSunRoofOpen){
    let target = {y:7, z:-4.3};
    let tween = new TWEEN.Tween(SunRoofPos).to(target, sunRoofOpenCloseTime).onUpdate(SunRoofOpen).onComplete(
        setSunRoofOpenStatus(true)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
  else{
    let target = {y:6.7906, z:-1.5443};
    let tween = new TWEEN.Tween(SunRoofPos).to(target, sunRoofOpenCloseTime).onUpdate(SunRoofOpen).onComplete(
        setSunRoofOpenStatus(false)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
}

const SunRoofOpen = () =>{
  sunRoof.position.y = SunRoofPos.y;
  sunRoof.position.z = SunRoofPos.z;
}

const setSunRoofOpenStatus = (val) =>{
  isSunRoofOpen = val;
}



const openConsoleBox = () => {
  consoleBox = threeJSScene.getObjectByName("mesh_Dashboard__ConsoleBox");
  if(!isConsoleBoxOpen){
    let target = {rot:-1.5708};
    let tween = new TWEEN.Tween(consoleBoxRotation).to(target, doorOpenCloseTime).onUpdate(ConsoleBoxOpen).onComplete(
        setConsoleBoxOpenStatus(true)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
  else{
    let target = {rot:0};
    let tween = new TWEEN.Tween(consoleBoxRotation).to(target, doorOpenCloseTime).onUpdate(ConsoleBoxOpen).onComplete(
        setConsoleBoxOpenStatus(false)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
}

const ConsoleBoxOpen = () =>{
  consoleBox.rotation.x = consoleBoxRotation.rot;
}

const setConsoleBoxOpenStatus = (val) =>{
  isConsoleBoxOpen = val;
}

const openGloveBox = () => {
  gloveBox = threeJSScene.getObjectByName("mesh_Dashboard__glovebox");
  if(!isGloveBoxOpen){
    let target = {rot:-0.610865};
    let tween = new TWEEN.Tween(gloveBoxRotation).to(target, doorOpenCloseTime).onUpdate(gloveBoxOpen).onComplete(
        setgloveBoxOpenStatus(true)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
  else{
    let target = {rot:0};
    let tween = new TWEEN.Tween(gloveBoxRotation).to(target, doorOpenCloseTime).onUpdate(gloveBoxOpen).onComplete(
        setgloveBoxOpenStatus(false)
        );
      tween.easing(TWEEN.Easing.Exponential.Out)
      tween.start();
  }
}

const gloveBoxOpen = () =>{
  gloveBox.rotation.x = gloveBoxRotation.rot;
}

const setgloveBoxOpenStatus = (val) =>{
  isGloveBoxOpen = val;
}

const openCloseDoor = () => {
  leftDoorGroup = threeJSScene.getObjectByName("LeftDoor");
  if(!isDoorOpen){
    let target = {rot:-1.13446};
    let tween = new TWEEN.Tween(doorRotation).to(target, doorOpenCloseTime).onUpdate(doorOpen).onComplete(
        setDoorOpenCloseStatus(true)
        );
      tween.easing(TWEEN.Easing.Exponential.InOut)
      tween.start();
  }
  else{
    let target = {rot:0};
    let tween = new TWEEN.Tween(doorRotation).to(target, doorOpenCloseTime).onUpdate(doorOpen).onComplete(
        setDoorOpenCloseStatus(false)
        );
      tween.easing(TWEEN.Easing.Exponential.InOut)
      tween.start();
  }
}
const doorOpen = () => {
  leftDoorGroup.rotation.z = doorRotation.rot;
}
const setDoorOpenCloseStatus = (val) => {
  isDoorOpen = val;
}


const showInterior = (val) => {
    // hide the handle hotspots
    doorHandleExt.visible = false;
    doorHandleInt.visible = false;
    controls.enabled = false;
  if(val){
    // open the left door
    if(!isDoorOpen){
      openCloseDoor();
    }

    // animate camera door position
    position = { cx : camera.position.x, cy:  camera.position.y, cz: camera.position.z , tx:controls.target.x, ty:controls.target.y, tz:controls.target.z};
    let target = { cx:camCarDoorOpnPos.x, cy:camCarDoorOpnPos.y, cz:camCarDoorOpnPos.z, tx:camTgtExtPos.x, ty:camTgtExtPos.y, tz:camTgtExtPos.z};
    let tween = new TWEEN.Tween(position).to(target, camAnimToDoorOpenPosTime).onUpdate(tweenPosition).onComplete(
    );
    tween.easing(TWEEN.Easing.Exponential.Out)
    tween.start();
    
    // after the camera is animated to door position
    // animate the camera into car
    setTimeout(function () {
      position = { cx : camera.position.x, cy:  camera.position.y, cz: camera.position.z , tx:controls.target.x, ty:controls.target.y, tz:controls.target.z};
      let target = { cx:camIntPos.x, cy:camIntPos.y, cz:camIntPos.z, tx:camTgtIntPos.x, ty:camTgtIntPos.y, tz:camTgtIntPos.z};
      let tween = new TWEEN.Tween(position).to(target, camAnimToCarInteriorTime).onUpdate(tweenPosition).onComplete(
        setCameraType("vr")
        );
      tween.easing(TWEEN.Easing.Exponential.InOut)
      tween.start();
    
      setTimeout(function () {
        // enable zooming
        isZoomEnabled = true;

        // close the car door after getting inside the car
        openCloseDoor();

        // set camera fov
        let targetCameraFov = { fov:75};
        let fovTween = new TWEEN.Tween(cameraProps).to(targetCameraFov, camAnimToCarInteriorTime).onUpdate(setCameraFov);
        fovTween.easing(TWEEN.Easing.Exponential.Out)
        fovTween.start();

        doorHandleInt.visible = true;
      }, camAnimToCarInteriorTime)
    }, camAnimToDoorOpenPosTime)
  }

  // animate the camera out of car
  else{
    // animate the camera to door open position
    openCloseDoor();
    setTimeout(function () {
      position = { cx : camera.position.x, cy:  camera.position.y, cz: camera.position.z , tx:controls.target.x, ty:controls.target.y, tz:controls.target.z};
      let target = {cx:camCarDoorOpnPos.x, cy:camCarDoorOpnPos.y, cz:camCarDoorOpnPos.z, tx:camTgtExtPos.x, ty:camTgtExtPos.y, tz:camTgtExtPos.z};
      let tween = new TWEEN.Tween(position).to(target, camAnimToCarInteriorTime).onUpdate(tweenPosition);
      tween.easing(TWEEN.Easing.Exponential.InOut)
      tween.start();

      // disable zooming
      isZoomEnabled = false;

      // animate the camera to default camera exterior position
      setTimeout(function () {
        position = { cx : camera.position.x, cy:  camera.position.y, cz: camera.position.z , tx:camTgtExtPos.x, ty:camTgtExtPos.y, tz:camTgtExtPos.z};
        let target = { cx:camExtPos.x, cy:camExtPos.y, cz:camExtPos.z , tx:camTgtExtPos.x, ty:camTgtExtPos.y, tz:camTgtExtPos.z};
        let tween = new TWEEN.Tween(position).to(target, camAnimToDoorOpenPosTime).onUpdate(tweenPosition).onComplete(
          setCameraType("normal")
          );
        tween.easing(TWEEN.Easing.Exponential.InOut)
        tween.start();
        openCloseDoor();
      }, camAnimToCarInteriorTime);

      // set camera fov
      let targetCameraFov = { fov:60};
      let fovTween = new TWEEN.Tween(cameraProps).to(targetCameraFov, camAnimToCarInteriorTime).onUpdate(setCameraFov);
      fovTween.easing(TWEEN.Easing.Exponential.Out)
      fovTween.start();

      // show exterior door handle hotspot
      setTimeout(function () {
        doorHandleExt.visible = true;
        controls.target.set(position.tx,position.ty,position.tz);
        controls.enabled = true;
      }, camAnimToDoorOpenPosTime+camAnimToCarInteriorTime);

    }, 1500);
  }
}

const dayNightSwitch = () =>{
  if(!isNightModeOn){
    let target = {dayOpacity:0, nightOpacity:1, fogBGClr:0, pointLight:0, headLights:1.2, nightSpot:0.5, carLights:1, carIntLight:0.3, metalRefEnvIntensity:0.45, chromeRefEnvIntensity:1, tyreRefEnvInt:0.3, lensFlareOpacity:1};
    let tween = new TWEEN.Tween(dayNightTweenProps).to(target, dayNightSwitchTime).onUpdate(setDayNight).onComplete(
      setNightModeToggleBool(true)
      );
    tween.easing(TWEEN.Easing.Exponential.Out)
    tween.start();
  }
  else{
    let target = {dayOpacity:1, nightOpacity:0, fogBGClr:255, pointLight:0.4, headLights:0, nightSpot:0, carLights:0, carIntLight:0, metalRefEnvIntensity:1.25, chromeRefEnvIntensity:3, tyreRefEnvInt:1, lensFlareOpacity:0};
    let tween = new TWEEN.Tween(dayNightTweenProps).to(target, dayNightSwitchTime).onUpdate(setDayNight).onComplete(
      setNightModeToggleBool(false)
      );
    tween.easing(TWEEN.Easing.Exponential.Out)
    tween.start();
  }
}

const setNightModeToggleBool = (val) => {
  isNightModeOn = val;
}

const setDayNight = () => {
  dayEnvironementMat.opacity = dayNightTweenProps.dayOpacity;
  nightEnvironementMat.opacity = dayNightTweenProps.nightOpacity;
  // console.log(threeJSScene.background.color);
  threeJSScene.background = new THREE.Color(`rgb(${parseInt(dayNightTweenProps.fogBGClr)},${parseInt(dayNightTweenProps.fogBGClr)},${parseInt(dayNightTweenProps.fogBGClr)})`);
  threeJSScene.fog.color.set(`rgb(${parseInt(dayNightTweenProps.fogBGClr)},${parseInt(dayNightTweenProps.fogBGClr)},${parseInt(dayNightTweenProps.fogBGClr)})`);
  pointLightF1.intensity = dayNightTweenProps.pointLight;
  pointLightRear1.intensity = dayNightTweenProps.pointLight;
  spotLigtNight.intensity = dayNightTweenProps.nightSpot;
  headlightL.intensity = dayNightTweenProps.headLights;
  headlightR.intensity = dayNightTweenProps.headLights;
  carLightsMtl.emissiveIntensity = dayNightTweenProps.carLights;
  intPlasticMtl.emissiveIntensity = dayNightTweenProps.carLights;
  carInteriorLightL.intensity = dayNightTweenProps.carIntLight;
  carInteriorLightR.intensity = dayNightTweenProps.carIntLight;

  //set less metal reflection for night mode
  threeJSScene.getObjectByName("mesh_Ext_object__A").material.envMapIntensity = dayNightTweenProps.metalRefEnvIntensity;
  threeJSScene.getObjectByName("mesh_Door__L").material.envMapIntensity = dayNightTweenProps.metalRefEnvIntensity;
  threeJSScene.getObjectByName("mesh_Door__R").material.envMapIntensity = dayNightTweenProps.metalRefEnvIntensity;
  threeJSScene.getObjectByName("mesh_Ext_object__Trunk").material.envMapIntensity = dayNightTweenProps.metalRefEnvIntensity;
  threeJSScene.getObjectByName("mesh_Tyre__C").material.envMapIntensity = dayNightTweenProps.tyreRefEnvInt;
  chromeMtl.envMapIntensity = dayNightTweenProps.chromeRefEnvIntensity;
  lensFlareMaterial.opacity = dayNightTweenProps.lensFlareOpacity;
}

const setCameraType = (type) =>{
  if(type === "vr"){
    // camera.lookAt(camTgtIntPos.x, camTgtIntPos.y, camTgtIntPos.z) ;
    setTimeout(function () {
      isCurrentViewInterior = true;
      const forward = new THREE.Vector3();
      camera.getWorldDirection(forward);
      forward.z = forward.z -0.9;
      controls.target.copy(camera.position).add(forward);
      controls.maxPolarAngle = 180;
      controls.enableZoom = false;
      controls.enabled = true;
    }, camAnimToDoorOpenPosTime+camAnimToCarInteriorTime)
  }
  else{
    controls.addEventListener('end', () => {});
    isCurrentViewInterior = false;
		controls.maxPolarAngle =  Math.PI * 0.49;
    controls.enableZoom = true;
  }
}

const tweenPosition = () => {
  // console.log(position, camera.target, camera.lookAt);
  camera.position.set(position.cx, position.cy, position.cz);
  camera.lookAt(new THREE.Vector3(position.tx, position.ty, position.tz));
}

const setCameraFov = () => {
  camera.fov = cameraProps.fov;
  camera.updateProjectionMatrix();
}

//#endregion

const componentToHex = (c) => {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

const rgbToHex = (r, g, b) =>{
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

const onWindowResize = () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize( window.innerWidth, window.innerHeight );
}


//#region Loading Spinner functions
const loadingSpinner = (on) => {
  if (on) {
      spinnerEl.classList.add('loading');
      backgroundEl.classList.add('absolute');
      backgroundEl.classList.remove('none');
  } else {
      spinnerEl.classList.remove('loading');
      backgroundEl.classList.remove('absolute');
      backgroundEl.classList.add('none');
  }
}



const threeJSClickEvents = ( event ) => {
  event.preventDefault();
  mouse.x = ( event.clientX / renderer.domElement.clientWidth ) * 2 - 1;
  mouse.y = - ( event.clientY / renderer.domElement.clientHeight ) * 2 + 1;
  raycaster.setFromCamera( mouse, camera );
  var intersects = raycaster.intersectObjects(threeJSSceneObjects); 
  if ( intersects !== undefined && intersects.length > 0 && !clickDrag) {
    if(intersects[0].object.name === "doorHandleExtHotspot"){
      showInterior(true);
    }
    else if(intersects[0].object.name === "doorHandleIntHotspot"){
      showInterior(false);
    }
    else if(metalObjectNames.indexOf(intersects[0].object.name) >= 0){
      if(colorPickerDom.style.visibility === "visible"){
        colorPickerDom.style.visibility = "hidden";
      }
      else{
        colorPickerDom.style.visibility = "visible";
        colorPickerDom = document.getElementsByClassName("sketch-picker")[0];
        colorPickerDom.style.left = `${event.clientX}px`;
        colorPickerDom.style.top = `${event.clientY}px`;
      }
    }
    else if(intersects[0].object.name === "mesh_Dashboard__glovebox"){
      openGloveBox();
      colorPickerDom.style.visibility = "hidden";
    }
    else if(intersects[0].object.name === "mesh_Dashboard__ConsoleBox"){
      openConsoleBox();
      colorPickerDom.style.visibility = "hidden";
    }    
    else if(intersects[0].object.name === "mesh_Sunroof_glass__A" || intersects[0].object.name === "mesh_SunRoof_Frame__B"){
      openCloseSunRoof();
      colorPickerDom.style.visibility = "hidden";
    }
    else{
      colorPickerDom.style.visibility = "hidden";
    }
  }
  else{
    colorPickerDom.style.visibility = "hidden";
  }
}



const runOnScroll = (e) =>{
  if(isZoomEnabled){
    if (e.deltaY === -100) {
    cameraProps.fov -= 5;
        if (cameraProps.fov<30) {cameraProps.fov=30}
        if (cameraProps.fov>90) {cameraProps.fov=90}
        camera.fov = cameraProps.fov
        camera.updateProjectionMatrix();
    }
    if (e.deltaY === 100) {
      cameraProps.fov += 5;
        if (cameraProps.fov<30) {cameraProps.fov=30}
        if (cameraProps.fov>90) {cameraProps.fov=90}
        camera.fov = cameraProps.fov
        camera.updateProjectionMatrix();
    }
  }
}


const setColorPicker = () =>{
  colorPickerDom = document.getElementsByClassName("sketch-picker")[0];
  colorPickerDom.style.position = "absolute";
  colorPickerDom.style.visibility = "hidden";
}





// const loadModel = (scene) => {
//   const loader = new GLTFLoader();
//   loader.crossOrigin = "anonymous";
//   loader.load('https://rawcdn.githack.com/mrdoob/three.js/76d16bd828c8d3e1870eac45aa466c20313cf944/examples/models/gltf/Nefertiti/Nefertiti.glb',(gltf) => {
    
//     const model = gltf.scene.children[0]
//     model.scale.multiplyScalar(0.3)
//     model.position.y = - 1.5
    
//     scene.add(model)
    
//     createMarker(model, new THREE.Vector3(5,20,30))
//     // createMarker(model, new THREE.Vector3(4,15,1.7))
//     // createMarker(model, new THREE.Vector3(-6,0,4))
//   })
  
  
// }


const createMarker = (x,y,z,name, planeSize) => {
  let loader = new TextureLoader();
  // loader.crossOrigin = "";
  let map = loader.load("hotspot.png");
  map.encoding = THREE.sRGBEncoding

  let geometry = new THREE.PlaneGeometry( planeSize, planeSize );
  let material = new THREE.MeshBasicMaterial( {map: map, side: THREE.DoubleSide, transparent:true, opacity:0.5} );
  let plane = new THREE.Mesh( geometry, material );
  plane.position.set(x,y,z);
  plane.rotation.y = 1.5708;
  plane.name = name;
  threeJSScene.add( plane );
  threeJSSceneObjects.push(plane);
  return plane;

  // const spriteMaterialFront = new THREE.SpriteMaterial( { map } );
  // spriteMaterialFront.name = "Door Handle";
  // // console.log(spriteMaterialFront.name);
  // const spriteFront = new THREE.Sprite( spriteMaterialFront );
  // spriteFront.position.copy(position) 
  // const spriteMaterialRear = new THREE.SpriteMaterial({ 
  //   map,
  //   opacity: 0.3, 
  //   transparent: true, 
  //   depthTest: false
  // });
  // const spriteRear = new THREE.Sprite( spriteMaterialRear );
  // spriteRear.position.copy(position) 
  // model.add(spriteFront, spriteRear)
}









export default class App extends React.Component {
  componentDidMount = () => {
    console.log("App Started...");
    this.createThreeJSScene();
    // showInterior();
    setColorPicker();
    
  }




  createThreeJSScene = () => {
    threeJSScene = new THREE.Scene();
    threeJSScene.background = new THREE.Color("rgb(255,255,255)");
    camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.001, 10000);
    let threejsDOM = document.getElementById("three_js");
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor( 0xffffff, 1 );

    threejsDOM.appendChild(renderer.domElement);
    camera.position.set(camExtPos.x, camExtPos.y, camExtPos.z, 2);
    // camera.position.set(camCarDoorOpnPos.x, camCarDoorOpnPos.y, camCarDoorOpnPos.z, 2);
    // camera.lookAt(60,6,6);
    // renderer.toneMapping = THREE.ReinhardToneMapping;
    // renderer.toneMappingExposure = 1.2;
    // renderer.shadowMap.enabled = true;
    // renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    // renderer.outputEncoding = THREE.sRGBEncoding;


    //### Lighting Setup ###//
  
    pointLightF1 = new THREE.PointLight(0xffffff, dayLightIntensity);
    pointLightF1.position.set(15,20,15);
    threeJSScene.add(pointLightF1);

    pointLightRear1 = new THREE.PointLight(0xffffff, dayLightIntensity);
    pointLightRear1.position.set(-15,20,-15);
    threeJSScene.add(pointLightRear1);

    spotLigtNight = new THREE.SpotLight(0xffffff, nightSpotLightIntensity);
    spotLigtNight.position.set(0,8,0);
    spotLigtNight.target.position.set(0,0,0);
    spotLigtNight.penumbra = 0.5;
    threeJSScene.add(spotLigtNight);

    carInteriorLightL = new THREE.SpotLight(0xffffff, carIntLightIntensity);
    carInteriorLightL.position.set(0,2.49,-0.19);
    carInteriorLightL.target.position.set(1,0,2.5);
    carInteriorLightL.penumbra = 0.1;
    carInteriorLightL.decay = 2;
    carInteriorLightL.distance=2;
    threeJSScene.add(carInteriorLightL);
    threeJSScene.add(carInteriorLightL.target);

    carInteriorLightR = new THREE.SpotLight(0xffffff, carIntLightIntensity);
    carInteriorLightR.position.set(0,2.49,-0.19);
    carInteriorLightR.target.position.set(-1,0,2.5);
    carInteriorLightR.penumbra = 0.1;
    carInteriorLightR.decay = 2;
    carInteriorLightR.distance=2;
    threeJSScene.add(carInteriorLightR);
    threeJSScene.add(carInteriorLightR.target);

    headlightL = new THREE.SpotLight(0xffffff, headLightIntensity);
    headlightL.position.set(-1.448, 1.322, 3.825);
    headlightL.target.position.set(-1.448, 1.322, 6);
    headlightL.penumbra = 1;
    headlightL.decay = 2;
    threeJSScene.add(headlightL);
    threeJSScene.add(headlightL.target);
    
    headlightR = new THREE.SpotLight(0xffffff, headLightIntensity);
    headlightR.position.set(1.448, 1.322, 3.825);
    headlightR.target.position.set(1.448, 1.322, 6);
    headlightR.penumbra = 1;
    headlightR.decay = 2;
    threeJSScene.add(headlightR);
    threeJSScene.add(headlightR.target);

    let hemiLight = new THREE.HemisphereLight( 0x7c7c7c, 0xffffff, 0.2 );
    threeJSScene.add( hemiLight );



    // lensflares
    // Option 1
    // let textureLoader = new THREE.TextureLoader();
    // let textureFlare0 = textureLoader.load( 'Textures/lensflare0.png' );

    // addLight( 1, 0.9, 0.8,  1.216, 1.285, 4.061);
    // addLight( 1, 0.9, 0.8,  -1.216, 1.285, 4.061);

    // function addLight( r, g, b, x, y, z ) {
    //   let light = new THREE.PointLight( 0xddffff, 0, 4000 );
    //   light.castShadow = false;
    //   light.color.setRGB( r, g, b );
    //   light.position.set( x, y, z );
    //   threeJSScene.add( light );

    //   let lensflare = new Lensflare();
    //   lensflare.addElement( new LensflareElement( textureFlare0, 150, 0, light.color ) );
    //   light.add( lensflare );
    // }



    // Option 2
    const createLensFlare = (x,y,z,material, width, height) =>{
      let geometry = new THREE.PlaneGeometry( width, height );
      let LFPlane = new THREE.Mesh( geometry, material );
      LFPlane.position.set(x,y,z);
      threeJSScene.add( LFPlane );
    }
    let textureLoader = new THREE.TextureLoader();
    let map = textureLoader.load("Textures/lensflare2.png");
    // map.encoding = THREE.sRGBEncoding
    lensFlareMaterial = new THREE.MeshPhongMaterial( {map: map, transparent:true, opacityMap:map, opacity:0, emissiveIntensity:1, emissive:0xc0c0c0} );


    createLensFlare(-1.216, 1.285, 4.06, lensFlareMaterial, 0.4, 0.25);
    createLensFlare(-1.459, 1.317, 3.802, lensFlareMaterial, 0.4, 0.25);
    createLensFlare(1.216, 1.285, 4.06, lensFlareMaterial, 0.4, 0.25);
    createLensFlare(1.459, 1.317, 3.802, lensFlareMaterial, 0.4, 0.25);


    //Option 3
    // let LFlight = new THREE.PointLight( 0xffffff, 0.1, 2000 );
    // LFlight.position.set(-1.23, 1.285, 4.3);
    // let textureLoader = new THREE.TextureLoader();

    // let textureFlare0 = textureLoader.load("Textures/lensflare2.png");
    // let lensflare = new Lensflare();
    // lensflare.addElement( new LensflareElement( textureFlare0, 64, 0 ) );

    // LFlight.add( lensflare );
    // threeJSScene.add(LFlight);




    //### Environment HDR Setup ###//

    // env hrd add
    // let environmentMap = new RGBELoader()
    //   .setPath('hdr/')
    //   .load('studio_hrd_02_v1.hdr', function (texture) {
    //     texture.mapping = THREE.EquirectangularReflectionMapping;
    //     fbxLoader.load("model/Dome.fbx", (model) => {
    //       let domeMaterial = new THREE.MeshLambertMaterial({
    //         map: texture,
    //       });
    //       model.traverse(m => {
    //         if (m.isMesh) {
    //           m.material = domeMaterial;
    //         }
    //       });
    //       threeJSScene.add(model);
    //     });
    //   });



    // 3D env add
    let environmentMapDay = new TextureLoader()
      .setPath('Textures/')
      .load('pattern.jpg', function (texture) {
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(15, 40);
    
        //load day environment mesh
        fbxLoader.load("model/environment.fbx", (model) => {
          // console.log("env loaded");
          dayEnvironementMat = new THREE.MeshBasicMaterial({
            // color:0xffffff,
            map: texture,
            lightMapIntensity:20,
            transparent:true
            // lightMap:texture
          });
          model.traverse(m => {
            if (m.isMesh) {
              m.material = dayEnvironementMat;
              m.side = THREE.DoubleSide;
            }
          });
          threeJSScene.add(model);
        });
      });

    let environmentMapNight = new TextureLoader()
      .setPath('Textures/')
      .load('pattern_night.jpg', function (texture) {
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(15, 40);
    
        //load night environment mesh
        fbxLoader.load("model/environment.fbx", (model) => {
          // console.log("env loaded");
          nightEnvironementMat = new THREE.MeshBasicMaterial({
            // color:0xffffff,
            map: texture,
            lightMapIntensity:20,
            transparent:true,
            opacity:0
          });
          model.traverse(m => {
            if (m.isMesh) {
              m.material = nightEnvironementMat;
              m.side = THREE.DoubleSide;
            }
          });
          threeJSScene.add(model);
        });
      });


      


    // // env ref hdr add
    // let environmentRefMap = new RGBELoader()
    //   .setPath('hdr/')
    //   .load('studio_hrd_02_v1.hdr', function (texture) {
    //     texture.mapping = THREE.EquirectangularReflectionMapping;
    //     texture.anisotropy = 20;
    //   });


    // env ref glass hdr add
    let environmentGlassRefMap = new TextureLoader().load('hdr/full-degree-equirectangular-panorama-hdri.jpg', function (texture) {
        texture.mapping = THREE.EquirectangularReflectionMapping;
      });

    // env ref glass hdr add
    let environmentDashBoardRefMap = new TextureLoader().load('hdr/studio_hrd_02_v1_ref.jpg', function (texture) {
      texture.mapping = THREE.EquirectangularReflectionMapping;
    });


    // add cube camera for reflection
    const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { format: THREE.RGBFormat, generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );

    cubeCamera = new THREE.CubeCamera(0.001, 100000, cubeRenderTarget);
    cubeCamera.position.set(0, 7, 0); 
    threeJSScene.add(cubeCamera);




    let animate = function () {
      requestAnimationFrame(animate);
      cubeCamera.update( renderer, threeJSScene );
      renderer.render(threeJSScene, camera);
      TWEEN.update();
    };



    //### Scene Fog Setup ###//

    let fogColor = "rgb(255,255,255)";  // white
    let fogNear = 5;
    let fogFar = 5;
    let fogDensity = 0.023;
    threeJSScene.fog = new THREE.Fog(fogColor, fogNear, fogFar);
    threeJSScene.fog = new THREE.FogExp2(fogColor, fogDensity);


    //### Texture Maps ###//
    // let metalGrainFlakes = new THREE.CanvasTexture(new FlakesTexture());
    // metalGrainFlakes.wrapS = THREE.RepeatWrapping;
    // metalGrainFlakes.wrapT = THREE.RepeatWrapping;
    // metalGrainFlakes.repeat.x = 800;
    // metalGrainFlakes.repeat.y = 800;

    // let bumpTexture = new THREE.CanvasTexture(new FlakesTexture());
    // bumpTexture.wrapS = THREE.RepeatWrapping;
    // bumpTexture.wrapT = THREE.RepeatWrapping;
    // bumpTexture.repeat.x = 20000;
    // bumpTexture.repeat.y = 20000;

    // let leatherBumpMap = new THREE.TextureLoader().load("textures/leather.jpg");
    // leatherBumpMap.wrapS = THREE.RepeatWrapping;
    // leatherBumpMap.wrapT = THREE.RepeatWrapping;
    // leatherBumpMap.repeat.set(50, 50);

    // let plasticBumpMap = new THREE.TextureLoader().load("textures/leather.jpg");
    // plasticBumpMap.wrapS = THREE.RepeatWrapping;
    // plasticBumpMap.wrapT = THREE.RepeatWrapping;
    // plasticBumpMap.repeat.set(10, 10);



    let loadMaterials = (meshName) =>{
      // split the name of meshes that have same bitmap materials
      let materialBitmapName = meshName;
      if (meshName.includes("__")){
        materialBitmapName = meshName.split("__")[0]
      }
      materialBitmapName = materialBitmapName.replace("mesh_","");

      let materials = {};
      for (let m=0; m < materialsNamesToLoad.length; m++ ){
      let bitmapPath = "";
      bitmapPath = `Textures/compressed/material_${materialsNamesToLoad[m]}_${materialBitmapName}.jpg`;
      if(materialMapNames.indexOf(`material_${materialsNamesToLoad[m]}_${materialBitmapName}.jpg`) >= 0){
        var xhr = new XMLHttpRequest();
        xhr.open('HEAD', bitmapPath, false);
        xhr.send();
        if (xhr.status !== "404") {
          let material = new THREE.TextureLoader().load(bitmapPath);
          materials[materialsNamesToLoad[m]] = material;
        }
      }      
    }
    return materials;
  }
    


    var meshMaterialTypes = {};
    metalObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "metalBody";
    });
    glassObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "glass";
    });
    glassWithOpacityMapObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "glassMap";
    });
    brushedMetalObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "brushedMetal";
    });
    chromeMirrorObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "chrome";
    });
    exteriorPlasticObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "extPlastic";
    });
    tyreObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "tyre";
    });
    seatObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "seat";
    });
    interiorPlastic.forEach(meshName => {
      meshMaterialTypes[meshName] = "intPlastic";
    });   
    fabricObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "fabric";
    });   
    carLightsObjectNames.forEach(meshName => {
      meshMaterialTypes[meshName] = "lights";
    });  



    // var gltfLoader = new GLTFLoader();

    // gltfLoader.load("Malebody (1).glb", (model) => {
    //   threeJSScene.add(model.scene);
    // });
    // loadingSpinner(false)

    // /*
    
    // console.log(meshMaterialTypes);
    //### Car model load & set materials by name ###//
    fbxLoader.load("model/Audi_model.fbx", (model) => {  
      // fbxLoader.load("model/Audi_RS5_model_optimized.fbx", (model) => {
      model.traverse(m => {
        if (m.isMesh) {
          // m.castShadow = true;
          // m.receiveShadow = true;
          threeJSSceneObjects.push(m);
          m.side =THREE.DoubleSide;
          let matBitmaps = loadMaterials(m.name);

          let roughnessMap = undefined;
          let opacityMap = undefined;
          let normalMap = undefined;
          let metalicMap = undefined;
          let emissiveMap = undefined;
          let diffuseMap = undefined;
          let aoMap = undefined;
          
          if (Object.size(matBitmaps)>0){
            for (let m in matBitmaps){
              switch(m){
                case "roughness":{
                    roughnessMap = matBitmaps[m];
                    break;
                  }
                case "opacity":{
                  opacityMap = matBitmaps[m];
                  break;
                }
                case "normal": {
                  normalMap = matBitmaps[m];
                  break;
                }
                case "metalic": {
                  metalicMap = matBitmaps[m];
                  break;
                }
                case "emissive": {
                  emissiveMap = matBitmaps[m];
                  break;
                }
                case "diffuse": {
                  diffuseMap = matBitmaps[m];
                  break;
                }
                case "ao": {
                  aoMap = matBitmaps[m];
                  break;
                }
                default:{}
              }
            }
          }

          switch(meshMaterialTypes[m.name]){

            case "metalBody": {
              if(metalBodyMtl === undefined || m.name.includes("Door") || m.name.includes("Trunk")){
                  metalBodyMtl = new THREE.MeshPhysicalMaterial({
                  map:diffuseMap,
                  roughness:0,
                  clearcoat :0,
                  metalness :0.06,
                  color: "#ffffff",
                  // normalMap: normalMap,
                  // normalMap:metalGrainFlakes,
                  // normalScale:(new THREE.Vector2(0.1,0.1)),
                  envMap: environmentGlassRefMap,
                  envMapIntensity:1.25,
                  side:THREE.DoubleSide
                });
              }
              m.material = metalBodyMtl;
              break;
            }


            case "glass": {
              let glassMtl1 = new THREE.MeshPhysicalMaterial({
                // map:diffuseMap,
                // color:0x000000,
                transmission:1,
                opacity:1,
                metalness:0,
                roughness:0,
                ior:20,
                clearcoat :0.8,
                clearcoatRoughness:0.4,
                envMap: environmentGlassRefMap,
                envMapIntensity:1.3,
                transparent:true,
                depthWrite:false,
                // side: THREE.DoubleSide
              });
              m.material = glassMtl1;
              break;
            }


           case "glassMap": {
              let glassMtl1 = new THREE.MeshPhysicalMaterial({
                // map:diffuseMap,
                color:0x000000,
                transmission:1,
                transmissionMap:opacityMap,
                opacity:1,
                metalness:0,
                roughness:0,
                ior:4,
                clearcoat :0.8,
                clearcoatRoughness:0.4,
                envMap: environmentGlassRefMap,
                envMapIntensity:1.3,
                transparent:true,
                // side: THREE.DoubleSide
              });
              m.material = glassMtl1;
              break;
            }

            case "brushedMetal": {
              let brushedMetalMtl = new THREE.MeshPhysicalMaterial({
                map:diffuseMap,
                metalness: 0.6,
                clearcoat: 0.6,
                // roughness: 0.85,
                roughnessMap:roughnessMap,
                envMap: environmentGlassRefMap,
                envMapIntensity:1,
                side: THREE.DoubleSide
              });
              m.material = brushedMetalMtl;
              break;
            }


            case "chrome": {
              if(chromeMtl === undefined){
                  chromeMtl = new THREE.MeshStandardMaterial({
                  metalness: 0.8,
                  roughness: 0.3,
                  color: 0x303030,
                  envMap: environmentGlassRefMap,
                  envMapIntensity:3,
                  side: THREE.DoubleSide
                });
              }
              m.material = chromeMtl;
              break;
            }


            case "extPlastic": {
              let extPlasticMtl = new THREE.MeshPhysicalMaterial({
                metalness: 1,
                roughness: 0.7,
                clearcoat:0,
                map:diffuseMap,
                normalMap:normalMap,
                envMap: environmentGlassRefMap,
                envMapIntensity:1.6,
                side: THREE.DoubleSide
              });
              m.material = extPlasticMtl;
              break;
            }


            case "tyre": {
              let tyreMtl = new THREE.MeshPhysicalMaterial({
                map: diffuseMap,
                normalMap :normalMap,
                // roughnessMap:roughnessMap,
                roughness: 0.8,
                metalness: 0.85,
                clearcoat :0,
                envMap: environmentGlassRefMap,
                envMapIntensity:1.7,
                side: THREE.DoubleSide
              });
              m.material = tyreMtl;
              break;
            }

            case "seat": {
              let seatMtl = new THREE.MeshPhysicalMaterial({
                map:diffuseMap,
                normalMap:normalMap,
                bumpMap:normalMap,
                bumpScale:2,
                metalness: 0.1,
                roughness:0.53,
                envMap: environmentGlassRefMap,
                envMapIntensity:1,
                side: THREE.DoubleSide
              });

              // let seatMtl = new THREE.MeshPhongMaterial({
              //   reflectivity:0.25,
              //   shininess:50,
              //   map:diffuseMap,
              //   normalMap:normalMap,
              //   envMap: environmentGlassRefMap,
              //   side: THREE.DoubleSide
              // });

              
              m.material = seatMtl;
              break;
            }

            case "intPlastic": {
              // if(intPlasticMtl == undefined){
                  intPlasticMtl = new THREE.MeshPhysicalMaterial({
                    metalness:0.3,
                  // reflectivity:0.35,
                  // shininess:40,
                  // specularMap:roughnessMap,
                  clearcoat:0,
                  roughnessMap:roughnessMap,
                  emissiveMap:emissiveMap,
                  emissive:0xffffff,
                  emissiveIntensity:1,
                  map:diffuseMap,
                  // specular:0xffffff,
                  normalMap:normalMap,
                  envMap: environmentDashBoardRefMap,
                  envMapIntensity:1.5,
                  side: THREE.DoubleSide
                });
              // }
              m.material = intPlasticMtl;
              break;
            }
            
            case "fabric": {
              let fabricMtl = new THREE.MeshStandardMaterial({
                roughness:1,
                map:diffuseMap,
                bumpMap:normalMap,
                bumpScale:0.005,
                // envMap: environmentCarInteriorRefMap,
                side: THREE.DoubleSide
              });
              m.material = fabricMtl;
              break;
            }
            
            case "lights": {
              if(carLightsMtl === undefined){
                  carLightsMtl = new THREE.MeshPhongMaterial({
                  reflectivity:0.65,
                  shininess:90,
                  emissiveMap:emissiveMap,
                  emissiveIntensity:0,
                  emissive:0xffffff,
                  map:diffuseMap,
                  normalMap:normalMap,
                  envMap: environmentGlassRefMap,
                  side: THREE.DoubleSide
                });
              }
              m.material = carLightsMtl;
              break;
            }


            default:{}
          }
           
          

        
        }
      })
      threeJSScene.add(model);
      loadingSpinner(false);
    });
   
    // */

    fbxLoader.load("model/plane.fbx", (model) => {
      model.traverse(m => {
        if (m.isMesh) {
          m.receiveShadow = true;
          let floorDiffuseMap = new THREE.TextureLoader().load("Textures/2021_12_02/material_diffuse_ground.jpg");
          let floorMaterial = new THREE.MeshStandardMaterial({
            map:floorDiffuseMap,
            color: 0xffffff,
          });
          let floorMtl = floorMaterial;
          m.material = floorMtl;
        }
      })
      threeJSScene.add(model);
    });
    
    // add markers / hotspots for interior / exterior views
    doorHandleExt = createMarker(1.83,1.58,-0.7, "doorHandleExtHotspot", 0.2);
    doorHandleInt = createMarker(1.36, 1.72,0.66, "doorHandleIntHotspot", 0.13 );


    animate();
    controls = new OrbitControls(camera, renderer.domElement);
    // controls.enableDamping = true;
    // controls.dampingFactor = 0.25;
    controls.enableZoom = true;
		// controls.minPolarAngle = 0;
		controls.maxPolarAngle =  Math.PI * 0.49;
    controls.enablePan = false;
    document.getElementById('btn_DayNight').addEventListener('click', function () {
      dayNightSwitch();
    });

    document.getElementById('btn_trunk').addEventListener('click', function () {
      // openCloseDoor();
      // openGloveBox();
      // openConsoleBox();
      // openCloseSunRoof();
      openCloseTrunk();
    });

    // click interactions with 3d models
    document.getElementById('three_js').addEventListener('click', (event) => {
      threeJSClickEvents(event);
    });

    // scroll zoom event
    document.getElementById('three_js').addEventListener("wheel", runOnScroll, true);

    // click / clickDrag click detection events
    document.addEventListener('mousedown', () => clickDrag = false);
    document.addEventListener('mousemove', () => clickDrag = true);

    window.addEventListener( 'resize', onWindowResize, false );

  }
  
  render() {
    return ( 
    <div id = "main_prj">
      <SketchPicker
        color={ "#FFFFFF" }
        onChangeComplete={ changeCarColor }
        // styles={colorPickerStyle}
      />
      <div className="homeTopPosition overview-overviewIcons-1clnh">
      <div className="overview-controlOuterStyle-2lAFj">
          <div className="common-iconInner-30Feb" id="btn_DayNight">
            <span>
              <svg className="overview-HomeIcon-ogSwQ" version="1.1" x="0px" y="0px" viewBox="0 0 20 20" xmlSpace="preserve">
                <g fill='#fff'>
                  <path d="M6.298,12.643c1.827-2.157,3.664-4.324,5.532-6.528
                    c-1.199-1.733-3.094-2.425-4.942-1.86C5.091,4.803,3.792,6.486,3.7,8.382C3.612,10.241,4.653,11.971,6.298,12.643z"/>
                  <path d="M15.424,15.862c-0.668-1.622-0.327-3.132,0.691-4.548
                    c-1.86-0.066-3.522,1.244-3.991,3.067c-0.506,1.968,0.342,3.954,2.093,4.901c1.638,0.888,3.685,0.576,4.805-0.777
                    C17.357,18.257,16.082,17.461,15.424,15.862z"/>
                  <path d="M18.969,0.195C19.047,0.111,4.051,18.921,4.051,18.921l0.55,0.566L19.516,0.763
                    C19.516,0.763,18.891,0.28,18.969,0.195z"/>
                  <path d="M14.367,2.22l-0.261-0.222c0,0-1.642,1.982-1.772,2.164s0.262,0.222,0.262,0.222
                    L14.367,2.22z"/>
                  <path d="M8.389,2.809L8.142,0L7.804,0.031c0,0,0.238,2.586,0.249,2.809
                    S8.389,2.809,8.389,2.809z"/>
                  <path d="M4.324,4.727L2.202,2.919L1.984,3.185c0,0,1.945,1.656,2.123,1.807
                    S4.324,4.727,4.324,4.727z"/>
                  <path d="M2.779,9.014C2.551,9.035,0.024,9.266,0.024,9.266l0.03,0.345L2.81,9.358
                    C2.81,9.358,3.006,8.993,2.779,9.014z"/>
                  <path d="M3.147,15.545c0,0,1.932-2.357,1.773-2.164c0,0-0.034-0.5-0.261-0.222
                    s-1.772,2.165-1.772,2.165L3.147,15.545z"/>
                </g>
              </svg>
            </span>
          </div>
          <div className="common-iconInner-30Feb" id="btn_trunk">
            <span>
              <svg className="overview-HomeIcon-ogSwQ" version="1.1" x="0px" y="0px" viewBox="0 0 20 20" xmlSpace="preserve">
                <path fill='#ffffff'
                    d="M12.714,15.323c-0.009,1.988-1.625,3.6-3.621,3.604
                    c-1.992,0.005-3.607-1.609-3.607-3.604c-0.001-2.043,1.629-3.67,3.646-3.641C11.134,11.713,12.722,13.328,12.714,15.323zM16.721,6.728c-0.972-0.003-1.946,0-2.919,0c-0.006-0.078-0.015-0.156-0.021-0.234
                    c1.697-1.039,3.386-2.089,5.094-3.109c0.585-0.351,0.823-0.694,0.379-1.354c-0.641-0.947-0.76-1.028-1.562-0.534
                    c-1.489,0.921-2.979,1.846-4.462,2.778c-1.578,0.992-1.576,1-3.063-0.096c-1.44-1.064-2.661-2.153-4.511-2.24
                    C4.023,1.861,2,1.825,1,1.799v1.668C2,3.802,3.59,5,4.427,7C3.103,7,2,7,1,7v9c1,0,2.086,0,3.372,0c0.395-3,1.936-4.995,4.289-5.139
                    c1.144-0.07,2.196,0.094,3.13,0.775c1.395,1.014,1.951,2.404,1.953,4.043c0.138,0.041,0.188,0.05,0.239,0.05
                    c1.027,0.006,2.053,0,3.078-0.003c1.48-0.009,2.432-0.941,2.45-2.411c0.017-1.27,0.011-2.54,0.008-3.808
                    C19.514,7.525,18.719,6.735,16.721,6.728z">
                </path>
              </svg>
            </span>
          </div>
      </div>
    </div>
    <div id = "three_js"/></div>
    );
  }
}